import { FormControl, Switch, Text } from '@chakra-ui/react';
import { PAGE_NUMBER_DISABLED, PAGE_NUMBER_ENABLED } from 'constants/mixpanel';
import { Mixpanel } from 'libs/third-party/Mixpanel/mixpanel';
import { useAppDispatch, useAppSelector } from 'modules/Editor/store';
import { selectHasPageNumber } from 'modules/Editor/store/infographSelector';
import { setPageNumberIsEnabled } from 'modules/Editor/store/infographSlice';
import { useTranslation } from 'react-i18next';
import { EDITABLE_PAGE_NUMBER_ID } from 'widgets/sdk/PageNumber/PageNumber.config';

import { labelWidth } from '../PageNumberMenu.config';

export const EnablePageNumber = () => {
  const hasPageNumber = useAppSelector(selectHasPageNumber);
  const dispatch = useAppDispatch();

  const onSetIsPageNumberEnabled = () => {
    const enablePageNumber = !hasPageNumber;
    dispatch(setPageNumberIsEnabled(enablePageNumber));

    if (enablePageNumber) {
      Mixpanel.track(PAGE_NUMBER_ENABLED.eventName);
      setTimeout(() => {
        // scroll page number into view if it exists
        const el = document.getElementById(EDITABLE_PAGE_NUMBER_ID);
        if (el) el.scrollIntoView({ behavior: 'smooth' });
      }, 0);
    } else {
      Mixpanel.track(PAGE_NUMBER_DISABLED.eventName);
    }
  };

  const { t } = useTranslation('common_navbar');
  const label = t('pageNumber.label');

  return (
    <FormControl display='flex' alignItems='center' gap={2}>
      <Text as='label' fontWeight='medium' width={labelWidth} fontSize='sm' htmlFor='page-numbers'>
        {label}
      </Text>
      <Switch size='sm' isChecked={hasPageNumber} onChange={onSetIsPageNumberEnabled} id='page-numbers' />
    </FormControl>
  );
};
